import { HeraldApplicationResponse } from '@common/types/herald/herald-types';
import { Typography } from '@common-components';
import { ModalBaseProps } from 'hooks';
import { Dialog, DialogContent, DialogFooter, DialogHeader } from 'components/Dialog';
import { MinimalFormProceedDialogMode } from './types';
import { useGetModeProps } from './useGetModeProps';

export interface MinimalFormProceedOpenDialogProps {
  mode: MinimalFormProceedDialogMode;
  heraldApplicationResponse?: HeraldApplicationResponse;
}

export interface MinimalFormProceedAdditionalDialogProps {
  onProceed: () => void;
}

export function MinimalFormProceedDialog({
  onProceed,
  isOpened,
  onClose,
  mode,
  heraldApplicationResponse,
}: MinimalFormProceedOpenDialogProps & ModalBaseProps & MinimalFormProceedAdditionalDialogProps) {
  const { header, content, proceedButton, cancelButton } = useGetModeProps({
    mode,
    onClose,
    onProceed,
    heraldApplicationResponse,
  });
  return (
    <Dialog open={isOpened} onClose={onClose} alertDialog>
      <DialogHeader id="minimal-form-proceed-dialog-header" title={header} onClose={onClose} />
      <DialogContent>
        <Typography variant="body1" color="textPrimary" sx={{ mb: 1 }}>
          {content}
        </Typography>
      </DialogContent>
      <DialogFooter proceedButton={proceedButton} cancelButton={cancelButton} />
    </Dialog>
  );
}
